import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Typography } from '@mui/material';
import React from 'react';
export function showDeleteFileDialog({ t, onConfirm, fileName }) {
    showConfirmDialog({
        title: t('missions.file.deleteDialog.title', { fileName }),
        content: (React.createElement(Typography, { variant: 'body1', color: themeColors.text.subtle, "data-test": 'confirm-delete-message' }, t('missions.file.deleteDialog.description'))),
        confirmLabel: t('missions.file.deleteDialog.submitButtonLabel'),
        onConfirm,
    });
}
